import React from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import { Clear } from "@churchofjesuschrist/eden-icons";
import {
  spacing16 as padding,
  backgroundColorLevelCurrent,
  yellow40,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import GenericSearch from "../../generic/generic-search/generic-search";
import manageStringsHelper from "../../utils/manage-strings-helper";
import useManagedStrings from "../../utils/use-managed-strings";

const RelativeRoot = styled.div`
  position: relative;
`;
const Bar = styled.div`
  background-color: ${yellow40};
  padding: ${padding};
  position: absolute;
  width: 100%;
  display: flex;
  z-index: 1;
`;
const Main = styled.div`
  max-width: 450px;
  flex: 100;
`;
const Left = styled.div`
  padding: 0 ${padding};
  flex: 1;
`;
const Right = styled.div`
  padding: 0 ${padding};
  flex: 1;
  color: ${backgroundColorLevelCurrent};
  display: flex;
  flex-direction: row-reverse;
`;

const stringGroups = [
  {
    name: "shared",
    keys: ["go", "invalidEmployeeId", "usernameNotFound", "enterUserNameToImpersonate"],
  },
];

const manageStrings = (strings) => {
  const managedStrings = manageStringsHelper(strings, stringGroups);
  return {
    go: managedStrings.go,
    invalid: managedStrings.invalidEmployeeId,
    notFound: managedStrings.usernameNotFound,
    placeholder: managedStrings.enterUserNameToImpersonate,
  };
};
const EmployeeIdSearch = ({
  onSearch = () => {},
  onCancel = () => {},
  notFound = false,
}) => {
  const { strings } = useManagedStrings(stringGroups);
  const useStrings = React.useMemo(() => manageStrings(strings), [strings]);

  return (
    //TODO: sort out number vs pattern for validation
    <RelativeRoot>
      <Bar>
        <Left></Left>
        <Main>
          <GenericSearch
            strings={useStrings}
            onSearch={onSearch}
            notFound={notFound}
            alertSeconds={3}
            data-id="employee-id-search"
          />
        </Main>
        <Right>
          <A11y type="reset" onClick={onCancel}>
            <Clear />
          </A11y>
        </Right>
      </Bar>
    </RelativeRoot>
  );
};

export default EmployeeIdSearch;
